import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../config/supabase';
import { Loader2 } from 'lucide-react';

const API = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

const AgentLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      const { data, error: err } = await supabase.auth.signInWithPassword({ email: email.trim().toLowerCase(), password });
      if (err) throw err;
      // Confirm this account is an agent
      const token = data.session?.access_token;
      const r = await fetch(`${API}/api/agencies/me`, { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) { await supabase.auth.signOut(); throw new Error('This portal is for external agents only.'); }
      navigate('/agent');
    } catch (e) {
      setError(e.message || 'Login failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg,#0A1A33 0%,#0f2547 100%)' }} data-testid="agent-login-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="mb-6">
          <span className="text-2xl font-extrabold text-slate-900">Jobasti<span className="text-blue-600">IQ</span></span>
          <p className="text-sm text-slate-500 mt-1">Agent portal — sign in to submit candidates.</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500" data-testid="agent-login-email" required />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500" data-testid="agent-login-password" required />
          {error && <p className="text-sm text-red-600" data-testid="agent-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-slate-300 text-white font-semibold py-2.5 rounded-lg flex items-center justify-center gap-2" data-testid="agent-login-submit">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
};

export default AgentLogin;
